// Xodim profili, uz
export default {
  noAccess: "Profil mavjud emas",
  noAccessDesc: "Bu xodim sizning filialingizdan tashqarida yoki profil mavjud emas.",
  breadcrumb: "Xodimlar",
  tabs: { overview: "Umumiy", drivers_one: "Driverlar ({{count}})", drivers_other: "Driverlar ({{count}})", pay: "Maosh va bonuslar", activity: "Faollik" },
  unblocked: "{{name}} blokdan chiqarildi",
  username: "Login",
  blocked: "Bloklangan",
  you: "Siz",
  noBranch: "Filialsiz",
  manager: "Menejer:",
  since: "Tizimda {{date}} dan beri",
  lastLogin: "oxirgi kirish {{when}}",
  neverLoggedIn: "hali kirmagan",
  twofaOn: "2FA yoqilgan",
  showDrivers: "Driverlarni ko'rish",
  unblock: "Blokdan chiqarish",
  block: "Bloklash",
  results: "Natijalar · {{month}}",
  kpi: {
    hires: "Ishga olinganlar (tasdiqlangan)",
    prev: "o'tgan oy: {{count}}",
    submitted: "Carrier'larga yuborilgan",
    waitingReply_one: "{{count}} ta javob kutmoqda",
    waitingReply_other: "{{count}} ta javob kutmoqda",
    newDrivers: "Yangi driverlar",
    calls: "Qo'ng'iroqlar",
    activities_one: "jami {{count}} ta faollik",
    activities_other: "jami {{count}} ta faollik",
    inPipeline: "Hozir jarayonda",
    pendingHires_one: "{{count}} ta yollash tasdiq kutmoqda",
    pendingHires_other: "{{count}} ta yollash tasdiq kutmoqda",
    timeToHire: "O'rtacha ishga olish vaqti",
    prevValue: "o'tgan oy: {{value}}",
    retention30: "30 kunlik saqlanish",
    overdue: "Kechikkan vazifalar",
    overdueSub: "e'tibor kerak",
    noOverdue: "hammasi o'z vaqtida",
  },
  trend: { title: "Oxirgi 6 oy", subtitle: "oyma-oy yuborilganlar va tasdiqlangan yollashlar", submitted: "Yuborilgan", hires: "Ishga olingan" },
  rank: "{{branch}} bo'yicha ishga olish o'rni · {{of}} tadan",
  bonus: { supplement: "qo'shimcha", title: "Shu oydagi bonus", basis: "{{hires}} ta yollash · {{retained}} tasi 30 kun qoldi", estimate: "taxminiy" },
  pipeline: { title: "Hozirgi jarayon", subtitle_one: "{{count}} ta faol driver", subtitle_other: "{{count}} ta faol driver" },
  funnel: { title: "Shu oydagi voronka", subtitle: "har bosqichga nechta driver yetib keldi" },
  retention: { title: "Saqlanish", subtitle: "ishga olinganlardan N kundan keyin ham ishlayotganlar" },
  drivers: {
    empty: "Driverlar yo'q",
    emptyDesc: "Bu xodimga biriktirilgan faol driver yo'q.",
    hint_one: "{{count}} ta driver · amallar uchun qatorga o'ng tugma bosing",
    hint_other: "{{count}} ta driver · amallar uchun qatorga o'ng tugma bosing",
    openList: "Driverlar ro'yxatida ochish",
    cols: { name: "Ism", phone: "Telefon", state: "Shtat", status: "Status", lastContact: "Oxirgi aloqa", nextAction: "Keyingi ish" },
  },
  pay: {
    chartTitle: "Oylar bo'yicha to'lov",
    chartSubtitle: "maosh va bonus, oxirgi 6 oy",
    salary: "Maosh",
    bonus: "Bonus",
    total12: "Oxirgi 12 oyda to'langan",
    total12Sub: "qayd etilgan maosh va bonuslar",
    unpaidSub: "yana {{amount}} hali to'lanmagan",
    salaries: "Maoshlar",
    noSalaries: "Hali maosh yozuvlari yo'q.",
    bonuses: "Bonuslar",
    noBonuses: "Hali bonuslar yo'q.",
    cols: { month: "Oy", amount: "Summa", status: "Holat", paidOn: "To'langan sana" },
    paid: "To'langan",
    unpaid: "To'lanmagan",
    monthTitle: "Maosh va bonus · {{month}}",
    monthHint: "oy sahifa tepasida tanlanadi",
    notSet: "Kiritilmagan",
    paidOn: "To'langan {{date}}",
    lastMonth: "o'tgan oy: {{amount}}",
    setSalary: "Maosh kiritish",
    changeAmount: "Summani o'zgartirish",
    markPaid: "To'landi deb belgilash",
    markUnpaid: "To'lanmagan deb belgilash",
    paidLocked: "To'langan maoshni faqat kompaniya egasi qaytara oladi",
    amount: "Summa",
    note: "Izoh",
    notePlaceholder: "Izoh, masalan: bank o'tkazmasi",
    salarySaved: "Maosh saqlandi · {{name}}",
    markedPaid: "To'landi deb belgilandi · {{name}}",
    markedUnpaid: "To'lanmagan deb belgilandi · {{name}}",
    bonusNone: "Hisoblanmagan",
    bonusEstimate_one: "Hozircha taxminan {{amount}} · {{count}} ta yollash",
    bonusEstimate_other: "Hozircha taxminan {{amount}} · {{count}} ta yollash",
    calculateInBudget: "Budjet → Bonuslar bo'limida hisoblash",
    adjust: "Tuzatish",
    approve: "Tasdiqlash",
    adjustment: "Tuzatish (+ yoki −)",
    adjustmentReason: "Sabab, masalan: tavsiya",
    calculated: "Qoida bo'yicha hisoblangan: {{amount}}",
    calcLine: "hisoblangan {{calculated}} · tuzatish {{adjustment}}",
    bonusAdjusted: "Bonus tuzatildi · {{name}}",
    bonusApproved: "Bonus tasdiqlandi · {{name}}",
    bonusPaid: "Bonus to'landi deb belgilandi · {{name}}",
  },
  activity: {
    title: "So'nggi faollik",
    subtitle: "shu xodim yozgan qo'ng'iroq va izohlar",
    empty: "Hali faollik yo'q",
    emptyDesc: "Xodim driverlar bo'yicha yozgan qo'ng'iroq va izohlar shu yerda chiqadi.",
    minutes: "{{count}} daq",
  },
  list: {
    title: "Xodimlar", team: "Jamoa",
    subtitle_one: "{{count}} xodim · {{period}}", subtitle_other: "{{count}} xodim · {{period}}",
    activity: { label: "Faollik", all: "Har qanday faollik", quiet_one: "{{count}}+ kun jim", quiet_other: "{{count}}+ kun jim", never: "Hech qachon faol emas" },
    newUser: "Yangi xodim", search: "Ism yoki login bo'yicha qidirish", showBlocked: "Bloklanganlarni ko'rsatish",
    roles: { all: "Hammasi", recruiter: "Recruiterlar", branch_manager: "Menejerlar", owner: "Egasi" },
    cols: { person: "Xodim", scope: "Filial", drivers: "Faol driverlar", new: "Yangi", submitted: "Yuborilgan", hired: "Ishga olingan", conv: "Konv.", calls: "Qo'ng'iroqlar", last: "Oxirgi faollik", overdue: "Kechikkan" },
    empty: "Bu filtrlarga mos xodim yo'q.", never: "Hali faollik yo'q", blocked: "Bloklangan", hint: "Qator bosilsa — xodim sahifasi. Davr natijalari status tarixidan hisoblanadi.",
  },
};
